export default "__VITE_ASSET__BQi50C$B__"